import moment from 'moment';
import 'moment/locale/fr';

export {
    moment as moment
}

export function momentDay(date = null) {
    if (date) {
        return moment(date).startOf('day');
    }
    return moment().startOf('day');
}

export function momentDayName(date = null) {
    return moment(date).format('dddd');
}

export function momentDaysAreSame(date1, date2) {
    if (!date1 || !date2) {
        return false;
    }
    return momentDay(date1).isSame(momentDay(date2));
}

export function momentDayFormatYmd(date) {
    return momentDay(date).format('YYYY-MM-DD');
}
